import React from 'react';
import PublicLayout from '../../components/PublicLayout';
import { Phone, GraduationCap, CheckCircle2, Waves } from 'lucide-react';

// Am eliminat "Instructaj" din array-urile de specializări pentru a-l folosi ca titlu
const COACHES = [
  {
    name: "Ovidiu Galeru",
    role: "Profesor • Antrenor • Coordonator",
    phone: "0745 312 668",
    specialties: ["Performanță"],
    education: [
      "Doctorat în Științele Educației",
      "Masterat în Psihologia Sportului de Performanţă",
      "Antrenor al Lotului Olimpic de Nataţie al României (JO Londra 2012, Rio 2016)"
    ],
    photo: "/team/ovidiu.jpeg" 
  },
  {
    name: "Cornelia Galeru",
    role: "Antrenor • Coordonator",
    phone: "0740 251 626",
    specialties: ["Inițiere", "Adulți", "PT"],
    education: [
      "Kinetoterapeut",
      "Masterat în Kinetoterapie",
      "Fostă medaliată la Campionatele Naţionale de copii şi juniori"
    ],
    photo: "/team/cornelia.jpeg"
  },
  {
    name: "Mara Nicola Galeru",
    role: "Antrenor",
    phone: "0758 071 073",
    specialties: ["Inițiere", "Copii", "Adulți", "PT"],
    education: [
      "Instructor de înot",
      "Licențiată în Comunicare și relații publice"
    ],
    photo: "/team/mara.jpeg"
  },
  {
    name: "Alexandru Petrișor Pojoreanu",
    role: "Antrenor",
    phone: "0742 468 649",
    specialties: ["Inițiere", "Copii", "Adulți", "Performanță", "PT"],
    education: [
      "Profesor de Educație Fizică și Sport",
      "Instructor de înot",
      "Masterand la Universitatea Vasile Alecsandri din Bacău",
      "Fost înotător de performanță"
    ],
    photo: "/team/pojoreanu.jpeg"
  },
  {
    name: "Sabin Jitaru",
    role: "Antrenor",
    phone: "0766 416 273",
    specialties: ["Inițiere", "Copii", "Adulți", "Performanță", "PT"],
    education: [
      "Masterat în Educaţie Fizică şi Sport",
      "Fost campion naţional de juniori şi multiplu medaliat",
      "Component al Lotului Național de Juniori al României"
    ],
    photo: "/team/sabin.jpeg"
  },
  {
    name: "Adrian Nicu Poeană",
    role: "Antrenor",
    phone: "0761 681 499",
    specialties: ["Inițiere", "Performanță"],
    education: [
      "Masterand în Performanță Sportivă",
      "Fost campion naţional de copii"
    ],
    photo: "/team/adrian.jpeg"
  },
  {
    name: "Alexandru Popa",
    role: "Antrenor",
    phone: "0749 038 205",
    specialties: ["Inițiere", "Performanță"],
    education: [
      "Masterand în Performanță Sportivă",
      "Fost înotător de performanţă"
    ],
    photo: "/team/alexandru-popa.jpeg"
  }
];

const OBJECTIVES = [
  {
    title: "Acomodarea cu apa",
    text: "Familiarizarea treptată cu mediul acvatic, eliminarea fricii de apă și dobândirea încrederii necesare pentru a înota corect și în siguranță.",
  },
  {
    title: "Imunitate & sănătate",
    text: "Înotul regulat întărește sistemul imunitar, îmbunătățește circulația și capacitatea respiratorie, pentru o stare generală de sănătate mai bună.",
  },
  {
    title: "Dezvoltare psihomotorie",
    text: "Stimularea coordonării, echilibrului și a abilităților psihosociale prin joc și interacțiune, într-un cadru organizat și sigur.",
  },
  {
    title: "Dezvoltare fizică armonioasă",
    text: "Înotul antrenează uniform toate grupele musculare, tonifică întregul corp și ajută la formarea unei ținute corecte.",
  },
  {
    title: "Creșterea rezistenței",
    text: "Îmbunătățirea capacității de efort și a anduranței cardio-respiratorii, pas cu pas, adaptat nivelului fiecărui sportiv.",
  },
  {
    title: "Performanță în competiții",
    text: "Pregătire specializată pentru cei care își doresc performanța, până la nivel competițional și participare la concursuri.",
  },
];

const AboutPage = () => {
  return (
    <PublicLayout>
      {/* Pe telefon/tabletă (< lg) echipa apare prima, apoi misiunea + obiectivele */}
      <div className="flex flex-col">
      {/* Misiune */}
      <section className="order-2 lg:order-1 pt-20 pb-20 lg:pt-32 lg:pb-24 bg-[#050505]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="max-w-3xl">
            <span className="text-[#6db025] text-xs font-heading uppercase tracking-[0.3em] mb-4 block">
              Misiunea Noastră
            </span>
            <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black text-white uppercase mb-8 leading-tight">
              Echipa și Valorile Sale
            </h1>
            <p className="text-white/70 text-xl leading-relaxed mb-12">
              Echipa Nautica este formată din profesori - antrenori cu experienţă şi vocaţie în activități cu copii,
              care pe parcursul orelor de înot vor urmări învăţarea şi perfecţionarea înotului în condiţiile cele mai bune.
            </p>
          </div>

          <div className="mt-16">
            <h2 className="font-heading text-3xl text-white uppercase font-bold mb-8">
              Obiective Principale
            </h2>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {OBJECTIVES.map((obj, i) => (
                <div
                  key={i}
                  className="flex flex-col gap-3 bg-white/5 p-6 border border-white/5 hover:border-[#6db025]/30 transition-colors"
                >
                  <div className="flex items-center gap-3">
                    <CheckCircle2 className="text-[#6db025] shrink-0" size={22} />
                    <h3 className="text-white font-heading text-lg font-bold uppercase tracking-wide leading-tight">
                      {obj.title}
                    </h3>
                  </div>
                  <p className="text-white/60 text-base leading-relaxed">{obj.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Echipa */}
      <section className="order-1 lg:order-2 pt-28 pb-20 lg:py-24 bg-[#0A0A0A]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-10 lg:mb-16">
            <span className="text-[#6db025] text-xs font-heading uppercase tracking-[0.3em] mb-4 block">
              Echipa Noastră
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-white uppercase">
              Profesionalism & Experiență
            </h2>
          </div>

          {/* 2 coloane de la 520px: tabletele mici (ex. Huawei MatePad, ~600px în portret) nu mai arată ca un telefon */}
          <div className="grid grid-cols-1 min-[520px]:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 lg:gap-8">
            {COACHES.map((coach, index) => (
              <div key={index} className="bg-[#121212] border border-white/5 flex flex-col h-full group hover:border-[#6db025]/30 transition-all duration-300">
                
                {/* Header Antrenor cu Animație de Zoom */}
                <div className="relative aspect-square min-[520px]:aspect-[4/5] overflow-hidden">
                  <img 
                    src={coach.photo} 
                    alt={coach.name} 
                    className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700 ease-in-out" 
                    onError={(e) => { e.target.src = 'https://images.unsplash.com/photo-1584380931214-dbb5b72e7fd0?w=400'; }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent opacity-80" />
                  <div className="absolute bottom-4 left-4 right-4 lg:bottom-6 lg:left-6 lg:right-6 z-10">
                    <h3 className="text-white font-heading text-xl lg:text-2xl font-black uppercase leading-none">{coach.name}</h3>
                    <p className="text-[#6db025] text-[10px] lg:text-xs font-heading uppercase tracking-widest mt-2">{coach.role}</p>
                  </div>
                </div>

                <div className="p-5 lg:p-8 flex-grow flex flex-col">
                  {/* Contact Rapid */}
                  <div className="mb-5 lg:mb-8">
                    <a href={`tel:${coach.phone.replace(/\s/g, '')}`} className="flex items-center gap-3 text-white/70 hover:text-[#6db025] transition-colors w-fit">
                      <Phone size={16} className="text-[#6db025]" />
                      <span className="font-heading text-sm lg:text-base uppercase tracking-wider">{coach.phone}</span>
                    </a>
                  </div>

                  {/* Secțiunea Instructaj - înălțime fixă pentru aliniere între carduri */}
                  <div className="mb-5 lg:mb-8">
                    <div className="flex items-center gap-2 mb-3">
                      <Waves size={16} className="text-[#6db025]" />
                      <span className="text-white/50 text-xs lg:text-sm font-heading uppercase tracking-widest">Instructaj</span>
                    </div>
                    <div className="flex flex-wrap content-start gap-1.5 lg:gap-2 min-h-[3.25rem] lg:min-h-[3.75rem]">
                      {coach.specialties.map((s, i) => (
                        <span key={i} className="text-[10px] lg:text-xs bg-[#6db025]/10 text-[#6db025] border border-[#6db025]/20 font-bold uppercase px-2 lg:px-2.5 py-1 rounded-sm">
                          {s}
                        </span>
                      ))}
                    </div>
                  </div>

                  {/* Educație / Realizări - aliniat la baza cardului */}
                  <div className="mt-auto pt-2 border-t border-white/5">
                    {/* Titlul secțiunii (aliniat pe aceeași linie între carduri) */}
                    <div className="flex items-center gap-2 mb-3 mt-4 lg:mb-4 lg:mt-6">
                      <GraduationCap size={16} className="text-[#6db025]" />
                      <span className="text-white/50 text-xs lg:text-sm font-heading uppercase tracking-widest">
                        Experiență & Studii
                      </span>
                    </div>

                    {/* Lista de realizări */}
                    <ul className="space-y-2 lg:space-y-3">
                      {coach.education.map((edu, i) => (
                        <li key={i} className="flex items-start gap-2.5 lg:gap-3 text-white/50 text-[13px] lg:text-sm leading-snug lg:leading-relaxed">
                          {/* Bullet aliniat cu prima linie de text */}
                          <div className="w-1.5 h-1.5 rounded-full bg-[#6db025]/50 shrink-0 mt-1.5 lg:mt-2" />
                          <span>{edu}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      </div>
    </PublicLayout>
  );
};

export default AboutPage;